// components/ExpressPage/ExpressPage.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CalendarModal from '../CalendarModal/CalendarModal';
import api from '../../services/api';

const ExpressPage = ({ onBack, onAddToCart, onAddMultipleToCart, onShowCartNotification }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState([]);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [expressServices, setExpressServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getIconForService = (serviceName, imageUrl) => {
    if (imageUrl && imageUrl !== '') return imageUrl;
    return '/icons/express-default.png';
  };

  useEffect(() => {
    const loadServices = async () => {
      setLoading(true);
      setError(null);
      try {
        // Подкатегория ID 11: Экспресс-тестирование
        const services = await api.getServicesBySubcategory(11);
        
        const mappedServices = services.map((service) => ({
          id: service.id,
          service_id: service.id,
          icon: getIconForService(service.name, service.image_url),
          name: service.name,
          price: service.price
        }));
        
        console.log('ExpressPage - загружено услуг:', mappedServices.length);
        setExpressServices(mappedServices);
      } catch (err) {
        console.error('Ошибка загрузки экспресс-услуг:', err);
        setError('Не удалось загрузить услуги');
      } finally {
        setLoading(false);
      }
    };
    
    loadServices();
  }, []);

  const toggleService = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleAddSelectedToCart = () => {
    if (selectedServices.length === 0) {
      showNotification('Выберите хотя бы один анализ');
      return;
    }

    const selectedServicesData = expressServices.filter(service => 
      selectedServices.includes(service.id)
    );
    
    selectedServicesData.forEach(service => {
      const cartItem = {
        id: service.id,
        service_id: service.id,
        name: service.name,
        price: service.price,
        category: 'Экспресс-анализы',
      };
      onAddToCart(cartItem);
    });

    if (onShowCartNotification) {
      onShowCartNotification(selectedServicesData.length);
    }

    setSelectedServices([]);
  };

  const handleBookAppointment = () => {
    if (selectedServices.length > 0) {
      setShowCalendarModal(true);
    } else {
      showNotification('Выберите анализы для записи');
    }
  };

  const handleCalendarConfirm = (selectedDate) => {
    const formattedDate = `${selectedDate.date.getDate().toString().padStart(2, '0')}.${(selectedDate.date.getMonth() + 1).toString().padStart(2, '0')}.${selectedDate.date.getFullYear()}`;
    const dayOfWeek = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'][selectedDate.date.getDay()];
    
    const selectedServicesData = expressServices.filter(service => 
      selectedServices.includes(service.id)
    );
    
    selectedServicesData.forEach(service => {
      const cartItem = {
        id: service.id,
        service_id: service.id,
        name: service.name,
        price: service.price,
        category: 'Экспресс-анализы',
        date: `${formattedDate} (${dayOfWeek})`
      };
      onAddToCart(cartItem);
    });
    
    if (onShowCartNotification) {
      onShowCartNotification(selectedServicesData.length);
    }
    
    setSelectedServices([]);
    setShowCalendarModal(false);
  };

  const showNotification = (message) => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.showAlert(message);
    } else {
      alert(message);
    }
  };

  const totalPrice = expressServices
    .filter(service => selectedServices.includes(service.id))
    .reduce((sum, service) => {
      const priceStr = service.price?.toString().replace(/[^\d.]/g, '') || '0';
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  const getServiceNames = () => {
    return selectedServices.map(id => {
      const service = expressServices.find(s => s.id === id);
      return service?.name;
    }).filter(Boolean).join(', ');
  };

  if (loading) {
    return (
      <div className="express-page">
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/express-default.png" alt={t('expressPage.title')} width="40" height="40" />
            </div>
            <h1>{t('expressPage.title')}</h1>
          </div>
        </header>
        <main className="main-content">
          <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
            Загрузка услуг...
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="express-page">
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/express-default.png" alt={t('expressPage.title')} width="40" height="40" />
            </div>
            <h1>{t('expressPage.title')}</h1>
          </div>
        </header>
        <main className="main-content">
          <div className="error-message" style={{ textAlign: 'center', padding: '40px', color: '#e74c3c' }}>
            {error}
            <button 
              className="service-btn" 
              onClick={() => window.location.reload()}
              style={{ marginTop: '20px' }}
            >
              Попробовать снова
            </button>
          </div>
        </main>
        <div className="buttons-grid">
          <button className="service-btn back-btn" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('expressPage.services.back')}</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="express-page">
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">
            <img src="/icons/express-default.png" alt={t('expressPage.title')} width="40" height="40" />
          </div>
          <h1>{t('expressPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('expressPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('expressPage.welcome')}</h2>
          <p className="subtitle">{t('expressPage.chooseAnalysis')}</p>
        </div>

        <div className="services-list-section">
          <div className="services-scroll-container">
            {expressServices.length > 0 ? (
              expressServices.map((service) => (
                <div 
                  key={service.id}
                  className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                  onClick={() => toggleService(service.id)}
                >
                  <div className="service-checkbox">
                    {selectedServices.includes(service.id) ? '✓' : ''}
                  </div>
                  <span className="btn-icon" style={{ width: '50px', height: '50px' }}>
                    <img 
                      src={service.icon} 
                      alt={service.name} 
                      width="40" 
                      height="40" 
                      style={{ objectFit: 'contain' }}
                      onError={(e) => {
                        e.target.src = '/icons/express-default.png';
                      }}
                    />
                  </span>
                  <div className="service-info">
                    <span className="service-name">{service.name}</span>
                    <span className="service-price">{service.price} ₽</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-services" style={{ textAlign: 'center', padding: '40px', color: 'rgba(255,255,255,0.7)' }}>
                <p>Услуги временно недоступны</p>
                <p style={{ fontSize: '12px', marginTop: '10px' }}>
                  Добавьте услуги в админ-панели:<br/>
                  Категория: "Лабораторная диагностика" → "Экспресс-тестирование"
                </p>
              </div>
            )}
          </div>
        </div>

        {selectedServices.length > 0 && (
          <div className="selected-services-summary">
            <div className="summary-header">
              <span className="summary-label">Выбрано анализов</span>
              <span className="summary-badge">{selectedServices.length}</span>
            </div>
            
            <div className="summary-total">
              <span className="total-label">Общая сумма</span>
              <span className="total-amount">{totalPrice.toLocaleString()} ₽</span>
            </div>

            <div className="summary-actions">
              <button 
                className="action-btn book-action"
                onClick={handleBookAppointment}
              >
                <span className="action-icon">📅</span>
                <span className="action-text">Записаться</span>
              </button>

              <button 
                className="action-btn cart-action"
                onClick={handleAddSelectedToCart}
              >
                <span className="action-icon">🛒</span>
                <span className="action-text">В корзину</span>
              </button>
            </div>
          </div>
        )}

        <div className="buttons-grid">
          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('expressPage.services.back')}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('expressPage.footer.main')}</p>
        <p className="footer-info">{t('expressPage.footer.info')}</p>
      </footer>

      <CalendarModal
        isOpen={showCalendarModal}
        onClose={() => setShowCalendarModal(false)}
        onConfirm={handleCalendarConfirm}
        serviceName={`Экспресс-анализы: ${getServiceNames().substring(0, 50)}${getServiceNames().length > 50 ? '...' : ''}`}
        servicePrice={`${totalPrice.toLocaleString()} ₽`}
      />
    </div>
  );
};

export default ExpressPage;